import "primevue/resources/themes/lara-light-purple/theme.css";
import "primevue/resources/primevue.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "./assets/layout/layout.scss";
import "./assets/layout/flags/flags.css";
import { createApp, reactive } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import Vuelidate from "@vuelidate/core";
import PrimeVue from "primevue/config";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import Card from "primevue/card";
import Password from "primevue/password";
import ProgressSpinner from "primevue/progressspinner";
import DataTable from "primevue/datatable";
import DataView from "primevue/dataview";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import Dialog from "primevue/dialog";
import Toolbar from "primevue/toolbar";
import InputNumber from "primevue/inputnumber";
import InputMask from "primevue/inputmask";
import Dropdown from "primevue/dropdown";
import AutoComplete from "primevue/autocomplete";
import Menu from "primevue/menu";
import Menubar from "primevue/menubar";
import Panel from "primevue/panel";
import PanelMenu from "primevue/panelmenu";
import Ripple from "primevue/ripple";
import OverlayPanel from "primevue/overlaypanel";
import Checkbox from "primevue/checkbox";
import Divider from "primevue/divider";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import SelectButton from "primevue/selectbutton";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Calendar from "primevue/calendar";
import ContextMenu from "primevue/contextmenu";
import BlockUI from "primevue/blockui";
import Message from "primevue/message";
import InlineMessage from "primevue/inlinemessage";
import Listbox from "primevue/listbox";
import MultiSelect from "primevue/multiselect";
import RadioButton from "primevue/radiobutton";
import Tooltip from 'primevue/tooltip';
import Badge from 'primevue/badge';
import Chip from 'primevue/chip';
import ProgressBar from 'primevue/progressbar';

import html2pdf from "html2pdf.js";
import VueSweetalert2 from "vue-sweetalert2";
import FileUpload from 'primevue/fileupload';
import CascadeSelect from 'primevue/cascadeselect';
import Tag from 'primevue/tag';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueSmartWidget from 'vue-smart-widget';



const app = createApp(App);
app.config.globalProperties.$appState = reactive({ inputStyle: "outlined" });
app.use(router);
app.use(store);
app.use(VueSmartWidget);
app.use(Vuelidate);


app.config.globalProperties.$axios = axios;

app.use(PrimeVue, { 
    
    
    ripple: true,
    ptOptions: { mergeProps: true },
    locale: {
        "startsWith": "Comience con",
        "contains": "Contenga",
        "notContains": "No contenga",
        "endsWith": "Termine con",
        "equals": "Igual a",
        "notEquals": "Diferente a",
        "noFilter": "Sin filtro",
        "lt": "Menor que",
        "lte": "Menor o igual a",
        "gt": "Mayor que",
        "gte": "Mayor o igual a",
        "dateIs": "Fecha igual a",
        "dateIsNot": "Fecha diferente a",
        "dateBefore": "Fecha antes de",
        "dateAfter": "Fecha después de",
        "custom": "Personalizar",
        "clear": "Limpiar",
        "apply": "Aplicar",
        "matchAll": "Coincidir todo",
        "matchAny": "Coincidir con cualquiera",
        "addRule": "Agregar regla",
        "removeRule": "Eliminar regla",
        "accept": "Sí",
        "reject": "No",
        "choose": "Escoger",
        "upload": "Subir",
        "cancel": "Cancelar",
        "fileSizeTypes": [
            "B",
            "KB",
            "MB",
            "GB",
            "TB",
            "PB",
            "EB",
            "ZB",
            "YB"
        ],
        "dayNames": [
            "Domingo",
            "Lunes",
            "Martes",
            "Miércoles",
            "Jueves",
            "Viernes",
            "Sábado"
        ],
        "dayNamesShort": [
            "Dom",
            "Lun",
            "Mar",
            "Mié",
            "Jue",
            "Vie",
            "Sáb"
        ],
        "dayNamesMin": [
            "D",
            "L",
            "M",
            "M",
            "J",
            "V",
            "S"
        ],
        "monthNames": [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre"
        ],
        "monthNamesShort": [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dic"
        ],
        "today": "Hoy",
        "now": "Ahora",
        "weekHeader": "Sem",
        "firstDayOfWeek": 1,
        "showMonthAfterYear": false,
        "dateFormat": "dd/mm/yy",
        "weak": "Débil",
        "medium": "Medio",
        "strong": "Fuerte",
        "passwordPrompt": "Escriba una contraseña",
        "emptyFilterMessage": "Sin opciones disponibles",
        "emptyMessage": "No se han encontrado resultados",
        "aria": {
            "trueLabel": "Verdadero",
            "falseLabel": "Falso",
            "nullLabel": "No seleccionado",
            "star": "1 estrella",
            "stars": "{star} estrellas",
            "selectAll": "Seleccionar todos",
            "unselectAll": "Deseleccionar todos",
            "close": "Cerrar",
            "previous": "Anterior",
            "next": "Siguiente",
            "navigation": "Navegación",
            "scrollTop": "Desplazarse hacia arriba",
            "moveTop": "Mover arriba",
            "moveUp": "Subir",
            "moveDown": "Bajar",
            "moveBottom": "Desplazarse hacia abajo",
            "moveToTarget": "Mover al objetivo",
            "moveToSource": "Mover al origen",
            "moveAllToTarget": "Mover todo al objetivo",
            "moveAllToSource": "Mover todo al origen",
            "pageLabel": "Página {page}",
            "firstPageLabel": "Primera Página",
            "lastPageLabel": "Última Página",
            "nextPageLabel": "Siguiente Página",
            "previousPageLabel": "Página Anterior",
            "rowsPerPageLabel": "Filas por página",
            "jumpToPageDropdownLabel": "Ir al menú desplegable de página",
            "jumpToPageInputLabel": "Ir a la entrada de página",
            "selectRow": "Seleccionar fila",
            "unselectRow": "Desmarcar fila",
            "expandRow": "Expandir Fila",
            "collapseRow": "Reducir Fila",
            "showFilterMenu": "Mostrar menú del filtro",
            "hideFilterMenu": "Ocultar menú del filtro",
            "filterOperator": "Operador de filtro",
            "filterConstraint": "Restricción de filtro",
            "editRow": "Editar fila",
            "saveEdit": "Guardar editado",
            "cancelEdit": "Cancelar editado",
            "listView": "Vista de lista",
            "gridView": "Vista de cuadrícula",
            "slide": "Deslizar",
            "slideNumber": "{slideNumber}",
            "zoomImage": "Ampliar imagen",
            "zoomIn": "Ampliar",
            "zoomOut": "Reducir",
            "rotateRight": "Girar a la derecha",
            "rotateLeft": "Girar a la izquierda"
         }
    }
});
app.use(ToastService);
app.use(VueSweetalert2);
app.use(html2pdf);
app.directive("ripple", Ripple);
app.directive('tooltip', Tooltip);

app.component("Badge", Badge);
app.component("Button", Button);
app.component("InputText", InputText);
app.component("Textarea", Textarea);
app.component("Card", Card);
app.component("Password", Password);
app.component("ProgressSpinner", ProgressSpinner);
app.component("DataTable", DataTable);
app.component("DataView", DataView);
app.component("Column", Column);
app.component("ColumnGroup", ColumnGroup);
app.component("Row", Row);
app.component("Dialog", Dialog);
app.component("Toolbar", Toolbar);
app.component("InputNumber", InputNumber);
app.component("InputMask", InputMask);
app.component("Dropdown", Dropdown);
app.component("AutoComplete", AutoComplete);
app.component("Menu", Menu);
app.component("Menubar", Menubar);
app.component("Panel", Panel);
app.component("PanelMenu", PanelMenu);
app.component("OverlayPanel", OverlayPanel);
app.component("Checkbox", Checkbox);
app.component("Divider", Divider);
app.component("Toast", Toast);
app.component("SelectButton", SelectButton);
app.component("Listbox", Listbox);
app.component("MultiSelect", MultiSelect);
app.component("RadioButton", RadioButton);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("Calendar", Calendar);
app.component("ContextMenu", ContextMenu);
app.component("BlockUI", BlockUI);
app.component("Message", Message);
app.component("InlineMessage", InlineMessage );
app.component("ProgressBar", ProgressBar);
app.component("Chip", Chip);
app.component("FileUpload", FileUpload);
app.component("CascadeSelect", CascadeSelect);
app.component("Tag", Tag);


app.mount("#app");